<template>
    <div style="width:100%; box-sizing: border-box;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>
    <GrcDialog ref="Dialog"></GrcDialog>

    <div style="width:100%; box-sizing: border-box; text-align: left;">

        <h2 class="painted_header_h2 color3"><span style="color:inherit; font-weight:500;">{{LevelTargy}}</span></h2>
        <br><br>

        <div class="infotext1">A hiánypótlás ügyében az ellátásszervezőtől kapott levelet alább találja.</div>


        <div class="level_tartalom" style="margin:10px 0px;">
        <div class="hianypotlas_header"># Hiányok pótlása</div>

        <GrcDocMultiSelect ref="docs" :grc_allowed_extensions="AllowedExtensions" :grc_maxfiles="MaxFiles" :grc_shownoti="ShowNoti" />


        <GrcTextArea ref="txtMegjegyzes"
        grc_labeltext="Megjegyzés:" grc_labelmode="above" grc_labelwidth="200px" 
        grc_areaheight="100px"
        style="margin-top:10px;"
        />


        <div class="btncont" style="text-align: center; margin: 10px 0px;">

            <span @click="btnOK_click" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                <span><i class="fal fa-check" style="margin-right: 4px;"></i>Hiánypótlás beküldése</span>
            </span>                                        

        </div>

        </div>

        <div class="level_tartalom" v-html="LevelTartalom" />


    </div>


    </div>
</template>

<script>

import GrcTextArea from '../GrcComponents/GrcTextArea.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'



export default {
  name: 'frmkritikus_hianypotlas',
  components: {
      GrcDB,
      GrcDialog,
      GrcTextArea,
      GrcDocDisplayer,
      GrcDocMultiSelect,
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmKritikus_Hianypotlas_",

          LevelID:0,
          LevelTartalom: "",
          LevelTargy:"",
          KritikusIgenyID:0,

        AllowedExtensions:"pdf, jpg, png",
        ShowNoti:"false",
        MaxFiles:"-1",



      }
  },
  model: {

  },  
  methods:{



    SetLang()
    {
      this.Init();
    },


      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      btnOK_click()
      {
        this.Mentes();
      },

      async Init()
      {

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iLevelID: this.LevelID,

        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            document.location = "dashboard";
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT.length == 0)
        {
            document.location = "dashboard";
            return;
        }

        this.LevelTartalom = Q.RESULT[0].Tartalom;
        this.LevelTargy = Q.RESULT[0].Targy;
        this.KritikusIgenyID = Q.RESULT[0].KritikusIgenyID;


      },


      async Mentes()
      {
        this.$refs.GRCDB.ShowLoading(false);

        var pFajlok = "";

        if (this.$refs.docs.GetFileCount() > 0)
        {

            var UploadRes = await this.$refs.docs.UploadFiles(1);
            if (UploadRes.Success == false) 
            { 
                this.$refs.GRCDB.HideLoading();
                this.ShowInfo("A dokumentum feltöltés előkészítése sikertelen!", 200);
                return;
            }
            
            pFajlok = pFajlok + "<DOCS>"
            +"<UploadID><![CDATA["+UploadRes.UploadID+"]]></UploadID>"
            +"<Megjegyzes><![CDATA["+UploadRes.Megjegyzes+"]]></Megjegyzes>"
            +"</DOCS>";

            pFajlok = "<NewDataSet>" + pFajlok + "</NewDataSet>";
        }
        

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iLevelID: this.LevelID,
            sFajlok: pFajlok,
            sMegjegyzes: this.$refs.txtMegjegyzes.GetText(),
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Save", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowInfo("Az adatok mentése sikeresen megtörtént!", 200);

        document.location = "dashboard";

      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },
  created()
  {

  },
  mounted()
  {
    this.LevelID = 0;
    if (GRCAPP_GetParameters.hasOwnProperty("MAILID"))
    {
        try
        {
            this.LevelID = parseInt(GRCAPP_GetParameters.MAILID);
        } catch
        {
            this.LevelID = 0;
        }
    }

    if (this.LevelID == 0)
    {
        document.location = "dashboard";
        return;
    }

    this.SetLang();

  }

}


</script>


<style scoped>

.hianypotlas_header
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:20px;
  line-height: 20px;
  color:var(--premblue);
  padding:0px;
  font-weight: 500;
  margin-bottom:20px;
}

.level_targy
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:15px;
  line-height: 18px;
  color:#444;
  padding:8px 4px;
  font-weight: 500;
}

.level_tartalom
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:18px;
  line-height: 26px;
  color:#444;
  padding:8px;
  border: solid 1px #ccc;
  border-radius: 3px;
  text-align: left; 
  background-color: rgba(200,200,200,0.2); 
}


.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}



.infotext1
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:16px;
  line-height: 22px;
  color:var(--premblue);
  padding:8px 0px;
  font-weight: 500;
  margin-bottom:0px;
  text-align: left;  

}



@media (max-width:670px)
{
    .level_tartalom
    {
        font-size:16px;
        line-height: 22px;
    }

}

</style>